import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import anime from 'animejs';

import site from '../../data/site.json';
import { Link } from '../Link';

// Use the new white horizontal logo from the static images folder
const LOGO_SRC = '/images/TX%20Fortress-Logo-White.png';
const LOGO_SRC_SET = `${LOGO_SRC} 1x, ${LOGO_SRC} 2x`;

class Component extends React.Component {
  static displayName = 'Brand';

  static propTypes = {
    theme: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    energy: PropTypes.object.isRequired,
    audio: PropTypes.object.isRequired,
    sounds: PropTypes.object.isRequired,
    className: PropTypes.any,
    link: PropTypes.string,
    hover: PropTypes.bool,
    stableTime: PropTypes.bool,
    onEnter: PropTypes.func,
    onExit: PropTypes.func,
    onLinkStart: PropTypes.func,
    onLinkEnd: PropTypes.func
  };

  static defaultProps = {
    link: '/'
  };

  constructor () {
    super(...arguments);

    const { energy, stableTime } = this.props;

    if (!stableTime) {
      energy.updateDuration({ enter: 820 });
    }
  }

  componentWillUnmount () {
    if (this.logoElement) {
      anime.remove(this.logoElement);
    }
  }

  enter () {
    const { energy, sounds, onEnter } = this.props;
    const logo = this.logoElement;

    if (!logo) {
      return;
    }

    anime.set(logo, { opacity: 0, scale: 0.9 });

    sounds.logo.play();

    anime({
      targets: logo,
      opacity: 1,
      scale: 1,
      easing: 'easeOutCubic',
      duration: energy.duration.enter,
      complete: () => onEnter && onEnter()
    });
  }

  exit () {
    const { energy, sounds, onExit } = this.props;
    const logo = this.logoElement;

    if (!logo) {
      return;
    }

    sounds.fade.play();

    anime({
      targets: logo,
      opacity: 0,
      scale: 0.95,
      easing: 'easeInCubic',
      duration: energy.duration.exit,
      complete: () => onExit && onExit()
    });
  }

  render () {
    const {
      theme,
      classes,
      energy,
      audio,
      sounds,
      className,
      link,
      hover,
      stableTime,
      onEnter,
      onExit,
      onLinkStart,
      onLinkEnd,
      ...etc
    } = this.props;

    return (
      <h1 className={cx(classes.root, hover && classes.hover, className)} {...etc}>
        <Link
          className={classes.link}
          href={link}
          title={`${site.name} logo`}
          onLinkStart={onLinkStart}
          onLinkEnd={onLinkEnd}
        >
          <span className={classes.title}>{site.name}</span>
          <img
            ref={ref => (this.logoElement = ref)}
            className={classes.logo}
            src={LOGO_SRC}
            srcSet={LOGO_SRC_SET}
            alt={`${site.name} logo`}
            onMouseEnter={() => sounds.hover.play()}
          />
        </Link>
      </h1>
    );
  }
}

export { Component };
